import { render, staticRenderFns } from "./product_item.vue?vue&type=template&id=cb2b9f2e&scoped=true&"
import script from "./product_item.vue?vue&type=script&lang=ts&"
export * from "./product_item.vue?vue&type=script&lang=ts&"
import style0 from "./product_item.vue?vue&type=style&index=0&id=cb2b9f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2b9f2e",
  null
  
)

export default component.exports